const state = {
  eventContext: null,
  manualNotifications: [],
  automatedNotifications: [],
  projects: [],
  control_points: [],
  control_points_stats: {
    related_to_me: {
      waiting_for_approval: 0,
      in_progress: 0,
      in_closure_process: 0,
      completed: 0,
    },
    all: {
      waiting_for_approval: 0,
      in_progress: 0,
      in_closure_process: 0,
      completed: 0,
    }
  },
};

export default state;
